<section class="page-section">

  <header class="header">
    <h1 translate class="title">FIRST_STEPS.WEB_CALL.INSTALLATION.TITLE</h1>
    <h6 translate class="subtitle">FIRST_STEPS.WEB_CALL.INSTALLATION.SUB_TITLE</h6>
  </header>

  <form [formGroup]="domainForm">

    <cc-box>
      <div
        class="box-item domain"
        header
        box>
        <span translate>LEAD_GENERATION.SETTINGS.ADD_WEBSIDE_FOR_CALLBACK_WIDGET</span>

        <div class="input-error-wrapper">
          <input
            matInput
            class="input form-control"
            placeholder="https://"
            formControlName="domainName"
          >
          <cc-input-errors
            [form]="domainForm"
            inputName="domainName"
            [errors]="[{'pattern': 'LEAD_GENERATION.ENTER_VALID_ADDRESS'}]">
          </cc-input-errors>
        </div>
      </div>
    </cc-box>


    <div class="guides-wrapper">
      <cc-web-call-installation-guide provider="JavaScript"></cc-web-call-installation-guide>
      <cc-web-call-installation-guide provider="Shopify"></cc-web-call-installation-guide>
      <cc-web-call-installation-guide provider="Wordpress"></cc-web-call-installation-guide>
    </div>


    <div class="actions-wrapper">
      <button
        mat-button
        mat-raised-button
        color="info-full"
        class="continue"
        (click)="doItLater()"
      >{{'LATER' | translate}}</button>

      <button
        mat-button
        mat-raised-button
        color="primary-full"
        class="continue"
        (click)="continueSteps()"
      >{{'NEXT' | translate}}</button>
    </div>

    <section class="check-code-installed-section">
      <h1 translate class="code-installed-text">LEAD_GENERATION.INSTALLATION.CHECK_INSTALL</h1>

      <form class="install-button-container" (submit)="handleCheckInstallationClick()">
        <input
          [(ngModel)]="checkInstallationUrl"
          matInput
          class="input form-control check-installation-url"
          name="url"
          placeholder="https://">

        <button
          [disabled]="checkingInstallation"
          mat-raised-button
          type="submit"
          color="primary-full"
        >
          {{ 'LEAD_GENERATION.SETTINGS.CHECK_INSTALLATION' | translate }}
        </button>
      </form>


    </section>

  </form>
</section>
